<div class="container-fluid mt-3">
    <div class="row column-mobile-reverse">
        <div class="col-md-5">
            <app-new-products></app-new-products>
        </div>
        <div class="col-md-7">
            <div class="d-flex justify-content-md-end sort-by-responsive">
                <ul class="list-inline mb-0 d-inline-flex align-items-center d-flex">
                    <li class="list-inline-item f-small ml-xl-3 text-uppercase" *ngIf="total > 0">
                        View
                    </li>
                    <li class="list-inline-item" *ngIf="total > 0">
                        <div class="form-group mb-0">
                            <select class="form-control dr-list new-select-box" (change)="changePerPage($event)">
                                <option value="30"
                                    [selected]="queryParams && queryParams.perPage && queryParams.perPage == 30">30
                                    items</option>
                                <option value="50"
                                    [selected]="queryParams && queryParams.perPage && queryParams.perPage == 50">50
                                    items</option>
                                <option value="100"
                                    [selected]="queryParams && queryParams.perPage && queryParams.perPage == 100">100
                                    items</option>
                                <option value="500"
                                    [selected]="queryParams && queryParams.perPage && queryParams.perPage == 500">500
                                    items</option>
                            </select>
                        </div>
                    </li>
                    <li class="list-inline-item f-small ml-xl-4 text-uppercase" *ngIf="total > 0">
                        Sort By:
                    </li>
                    <li class="list-inline-item" *ngIf="total > 0">
                        <div class="form-group mb-0">
                            <select class="form-control dr-list new-select-box" (change)="changeSort($event)">
                                <option value="newest"
                                    [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'newest'">
                                    Newest (default) </option>
                                <option value="price_low_to_high"
                                    [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_low_to_high'">
                                    Price low to high</option>
                                <option value="price_high_to_low"
                                    [selected]="queryParams && queryParams.sortBy && queryParams.sortBy == 'price_high_to_low'">
                                    Price high to low</option>
                            </select>
                        </div>
                    </li>

                    <li class="ml-xl-4">
                        <a href="#">
                            <img src="/assets/img/download-icon.svg" alt="Download" width="30px" />
                        </a>
                    </li>

                    <li class="ml-xl-4 grid-icon-style">
                        <a class="cp" *ngIf="!showFirstIcon" (click)="toggleIcon()">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M14 5.6C14 5.03995 14 4.75992 14.109 4.54601C14.2049 4.35785 14.3578 4.20487 14.546 4.10899C14.7599 4 15.0399 4 15.6 4H18.4C18.9601 4 19.2401 4 19.454 4.10899C19.6422 4.20487 19.7951 4.35785 19.891 4.54601C20 4.75992 20 5.03995 20 5.6V8.4C20 8.96005 20 9.24008 19.891 9.45399C19.7951 9.64215 19.6422 9.79513 19.454 9.89101C19.2401 10 18.9601 10 18.4 10H15.6C15.0399 10 14.7599 10 14.546 9.89101C14.3578 9.79513 14.2049 9.64215 14.109 9.45399C14 9.24008 14 8.96005 14 8.4V5.6Z"
                                        stroke="#000000" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M4 5.6C4 5.03995 4 4.75992 4.10899 4.54601C4.20487 4.35785 4.35785 4.20487 4.54601 4.10899C4.75992 4 5.03995 4 5.6 4H8.4C8.96005 4 9.24008 4 9.45399 4.10899C9.64215 4.20487 9.79513 4.35785 9.89101 4.54601C10 4.75992 10 5.03995 10 5.6V8.4C10 8.96005 10 9.24008 9.89101 9.45399C9.79513 9.64215 9.64215 9.79513 9.45399 9.89101C9.24008 10 8.96005 10 8.4 10H5.6C5.03995 10 4.75992 10 4.54601 9.89101C4.35785 9.79513 4.20487 9.64215 4.10899 9.45399C4 9.24008 4 8.96005 4 8.4V5.6Z"
                                        stroke="#000000" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M4 15.6C4 15.0399 4 14.7599 4.10899 14.546C4.20487 14.3578 4.35785 14.2049 4.54601 14.109C4.75992 14 5.03995 14 5.6 14H8.4C8.96005 14 9.24008 14 9.45399 14.109C9.64215 14.2049 9.79513 14.3578 9.89101 14.546C10 14.7599 10 15.0399 10 15.6V18.4C10 18.9601 10 19.2401 9.89101 19.454C9.79513 19.6422 9.64215 19.7951 9.45399 19.891C9.24008 20 8.96005 20 8.4 20H5.6C5.03995 20 4.75992 20 4.54601 19.891C4.35785 19.7951 4.20487 19.6422 4.10899 19.454C4 19.2401 4 18.9601 4 18.4V15.6Z"
                                        stroke="#000000" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                    <path
                                        d="M14 15.6C14 15.0399 14 14.7599 14.109 14.546C14.2049 14.3578 14.3578 14.2049 14.546 14.109C14.7599 14 15.0399 14 15.6 14H18.4C18.9601 14 19.2401 14 19.454 14.109C19.6422 14.2049 19.7951 14.3578 19.891 14.546C20 14.7599 20 15.0399 20 15.6V18.4C20 18.9601 20 19.2401 19.891 19.454C19.7951 19.6422 19.6422 19.7951 19.454 19.891C19.2401 20 18.9601 20 18.4 20H15.6C15.0399 20 14.7599 20 14.546 19.891C14.3578 19.7951 14.2049 19.6422 14.109 19.454C14 19.2401 14 18.9601 14 18.4V15.6Z"
                                        stroke="#000000" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </a>
                        <a class="cp" *ngIf="showFirstIcon" (click)="toggleIcon()">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M8 6.00067L21 6.00139M8 12.0007L21 12.0015M8 18.0007L21 18.0015M3.5 6H3.51M3.5 12H3.51M3.5 18H3.51M4 6C4 6.27614 3.77614 6.5 3.5 6.5C3.22386 6.5 3 6.27614 3 6C3 5.72386 3.22386 5.5 3.5 5.5C3.77614 5.5 4 5.72386 4 6ZM4 12C4 12.2761 3.77614 12.5 3.5 12.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5C3.77614 11.5 4 11.7239 4 12ZM4 18C4 18.2761 3.77614 18.5 3.5 18.5C3.22386 18.5 3 18.2761 3 18C3 17.7239 3.22386 17.5 3.5 17.5C3.77614 17.5 4 17.7239 4 18Z"
                                        stroke="#000000" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </g>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="pbb-line"></div>
        </div>
    </div>
</div>
<section class="mt-3 mb-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 col-lg-3">
                <h3 class="bold mb-3">Accessories</h3>
                <app-accessories-filters [filters]="filters" [currentFragment]="currentFragment"
                    [selectedFilters]="queryParams" (onFilter)="onFilter($event)"></app-accessories-filters>
            </div>
            <div class="col-md-8 col-lg-9">

                   
                

                <div class="row">
                    <div class="col-md-12 br-left">

                        <div
                            class="border-btm d-flex justify-content-between align-items-lg-center flex-lg-row mb-3 flex-column">
                            <div class="accessories-tab new-tabs-style mb-0">
                                <ul class="nav nav-tabs nav-justified search-nav-tabs self-tabs" id="myTab"
                                    role="tablist">
                                    <li class="nav-item" *ngFor="let cat of categories">
                                        <a class="nav-link" [class.active]="currentFragment === cat.slug"
                                            routerLink="./" [fragment]="cat.slug" data-toggle="tab" role="tab"
                                            [attr.aria-controls]="cat.slug"
                                            [attr.aria-selected]="currentFragment === cat.slug">{{ cat.name }}</a>
                                    </li>
                                </ul>
                            </div>

                            <span class="d-none d-lg-block text-right" *ngIf="total > 0" style="font-size: 10px;">
                                Showing {{from}}-{{to}} of {{total}} Accessories
                            </span>
                        </div>

                        <span class="d-lg-none d-flex" *ngIf="total > 0" style="font-size: 10px;">
                            Showing {{from}}-{{to}} of {{total}} Accessories
                        </span>

                        <div class="list-view" *ngIf="showFirstIcon">
                            <div class="tab-content">
                                <div *ngFor="let cat of categories" [class.active]="currentFragment === cat.slug"
                                    [class.show]="currentFragment === cat.slug" class="tab-pane fade" role="tabpanel"
                                    [attr.aria-labelledby]="cat.slug">
                                    <!-- <div class="table-responsive">
                                        <table class="table details-table">
                                            <tbody>
                                                <app-preloader *ngIf="isLoading"></app-preloader>
                                                <span *ngIf="!isLoading && addOns.length === 0">No Add Ons found</span>
                                                <tr *ngFor="let addOn of addOns">
                                                    <td align="middle" class="text-center">
                                                        <img [src]="addOn.image_1 | imagePath" class="accrs-img" />
                                                    </td>
                                                    <td>
                                                        <h6 class="bold text-capitalize m-0">{{ addOn.title }}</h6>
                                                        <p class="m-0" *ngIf="addOn.part_number">Part No : {{
                                                            addOn.part_number }}</p>
                                                    </td>
                                                    <td>
                                                        {{ addOn?.discounted_price | currency:
                                                        addOn?.vendor?.currency:'symbol' }}
                                                    </td>
                                                    <td>
                                                        <span class="in-stk" *ngIf="addOn.total_quantity > 0">In
                                                            Stock</span>
                                                        <span class="out-stk" *ngIf="addOn.total_quantity <= 0">Out Of
                                                            Stock</span>
                                                    </td>
                                                    <td>
                                                        <a [routerLink]="['/accessories-details', cat.slug, addOn.part_number, addOn.id]"
                                                            class="view-style no-styling">View</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->

                                    <div class="row f-details">
                                        <div class="col-md-12">
                                            <app-preloader *ngIf="isLoading"></app-preloader>
                                            <span *ngIf="!isLoading && addOns.length === 0" class="text-black">No Add
                                                Ons found</span>
                                        </div>


                                        <div class="col-md-12" *ngFor="let addOn of addOns; let i = index">
                                            <div class="row">
                                                <div class="col-md-12 col-lg-4">
                                                    <img [src]="addOn.image_1 | imagePath"
                                                        class="img-fluid mb-4 mx-auto d-block access-height"
                                                        alt="img" />
                                                </div>
                                                <div class="col-md-12 col-lg-8">
                                                    <div class="product-top">
                                                        <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">


                                                            <h3 class="bold mb-0">{{ addOn.vendor.business_name }}</h3>
                                                            <h5 class="mb-3"> {{ addOn.title }}</h5>
                                                        </div>
                                                        <div
                                                            class="col-md-12 col-lg-6 col-sm-12 col-xs-12 flex-column increase-font2 d-flex justify-content-between">
                                                            <div class="product-top d-flex align-items-end flex-column">
                                                                <div class="increase-font2">
                                                                    <span class="mb-0 fw-sb"
                                                                        *ngIf="addOn.part_number">SKU:
                                                                        {{addOn.part_number}}</span>
                                                                </div>
                                                                <div class="increase-font2">
                                                                    <span class="fw-sb">MSRP:</span>
                                                                    <span class="ml-3 fw-sb">{{ addOn?.price | currency:
                                                                        addOn?.vendor?.currency:'symbol' }}</span>
                                                                </div>
                                                            </div>
                                                            <div class="product-top d-flex align-items-end flex-column"
                                                                *ngIf="is_hide_cost == null">
                                                                <div class="increase-font2 p-0">
                                                                    <span class="bold npc pb ">Your Price:</span>
                                                                    <span class="ml-3 bold npc pb">{{
                                                                        addOn?.discounted_price | currency:
                                                                        addOn?.vendor?.currency:'symbol' }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-md-12 flex-column flex-sm-row align-items-sm-center  flex-lg-row align-items-lg-center flex d-flex justify-content-between align-items-start mt-4 mb-3 qty-cartbtn-container">
                                                        <div class="d-flex align-items-center">
                                                            <div class="custom-label new-quantity-box"
                                                                *ngIf="addOn.total_quantity > 0">
                                                                <div
                                                                    class="input-group custom-adder custom-adder-rw position-relative">
                                                                    <input type="button" value="-" class="button-minus"
                                                                        (click)="decrementQuantity($event)">
                                                                    <input type="number" step="1" [min]="minQuantity"
                                                                        [value]="quantity" name="quantity"
                                                                        class="quantity-field">
                                                                    <input type="button" value="+" class="button-plus"
                                                                        (click)="incrementQuantity($event)">
                                                                    <label class="f-light">Quantity</label>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <p class="mb-0 cp text-du max-text"
                                                                        *ngIf="addOn.total_quantity > 0"
                                                                        data-toggle="modal" data-target="#stockModal"
                                                                        (click)="getAddonByAccessory(addOn.id, $event)">
                                                                        {{addOn.total_quantity }} in stock
                                                                    </p>
                                                                    <p class="mb-0 out-stk"
                                                                        *ngIf="addOn.total_quantity <= 0">
                                                                        Out of stock
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <a [routerLink]="['/accessories-details', cat.slug, addOn.part_number, addOn.id]"
                                                                *ngIf="addOn.total_quantity > 0"
                                                                class="btn btn-02 f-large addcart new-btn cart-detils text-uppercase">
                                                                <span>View Details</span>
                                                            </a>
                                                            <button type="button"
                                                                class="btn btn-02 f-large addcart ml-3 new-btn cart-btn text-uppercase"
                                                                *ngIf="addOn.total_quantity > 0"
                                                                (click)="addToCart(addOn.id, $event)">
                                                                <span>ADD TO CART</span>
                                                            </button>
                                                            <button type="button"
                                                                class="btn btn-02 f-large addcart ml-3 new-btn notify-btn cart-btn"
                                                                *ngIf="addOn.total_quantity <= 0" (click)="notifyWhenAvailable(addOn.id)">
                                                                <span>Notify Me when Available</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr *ngIf="(i + 1) % 1 == 0" style="width: 96%; margin-bottom: 30px;" />
                                        </div>



                                    </div>

                                </div>


                            </div>
                        </div>


                        <div class="grid-view" *ngIf="!showFirstIcon">

                            <div class="tab-content">
                                <div *ngFor="let cat of categories" [class.active]="currentFragment === cat.slug"
                                    [class.show]="currentFragment === cat.slug" class="tab-pane fade" role="tabpanel"
                                    [attr.aria-labelledby]="cat.slug">
                                    <div class="row f-details m-0">
                                        <div class="col-md-6 col-lg-6 col-xl-4 border-product"
                                            *ngFor="let addOn of addOns">
                                            <div class="row">
                                                <div class="col-md-12">

                                                    <div class="img-wrap">
                                                        <img [src]="addOn.image_1 | imagePath" 
                                                        class="img-fluid mx-auto d-block" alt="img" />
                                                    </div>
                                                    

                                                    <div class="product-top flex-column text-center">
                                                        <h5 class="mb-0 " *ngIf="addOn.part_number">SKU : {{
                                                            addOn.part_number }}</h5>
                                                        <h3 class="mb-0 fw-sb">{{ addOn.vendor.business_name }}</h3>
                                                        <h5 class="mb-0 mt-3">{{ addOn.title }}</h5>
                                                        <!-- <h5 class=""> {{ product?.model?.name }} {{
                                                      product?.finish?.finish}}</h5> -->

                                                    </div>

                                                    <div
                                                        class="d-flex flex-md-column flex-lg-row justify-content-between align-items-md-center mb-4 less-font">
                                                        <div class="increase-font2">
                                                            <span class="text-black npc">MSRP:</span>
                                                            <span class="ml-1 text-black npc">{{ addOn?.price |
                                                                currency:
                                                                addOn?.vendor?.currency:'symbol' }}</span>
                                                        </div>
                                                        <div class="product-top d-flex align-items-end flex-column"
                                                            *ngIf="is_hide_cost == null">
                                                            <div class="increase-font2 p-0">
                                                                <span class="bold npc pb">Cost:</span>
                                                                <span class="ml-3 bold npc pb">{{
                                                                    addOn?.discounted_price | currency:
                                                                    addOn?.vendor?.currency:'symbol' }}</span>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="d-flex justify-content-between align-items-center mb-2 flex-md-column flex-lg-row grid-last-section qty-cartbtn-container"
                                                        *ngIf="addOn.total_quantity > 0">
                                                        <div>


                                                            <p class="mb-0 cp text-du max-text"
                                                                *ngIf="addOn.total_quantity > 0" data-toggle="modal"
                                                                data-target="#stockModal"
                                                                (click)="getAddonByAccessory(addOn.id, $event)">
                                                                {{addOn.total_quantity }} in stock</p>
                                                        </div>

                                                        <div class="custom-label new-quantity-box"
                                                            *ngIf="addOn.total_quantity > 0">
                                                            <div
                                                                class="input-group custom-adder custom-adder-rw position-relative">
                                                                <input type="button" value="-" class="button-minus"
                                                                    (click)="decrementQuantity($event)">
                                                                <input type="number" step="1" [min]="minQuantity"
                                                                    [(ngModel)]="quantity" name="quantity"
                                                                    class="quantity-field">
                                                                <input type="button" value="+" class="button-plus"
                                                                    (click)="incrementQuantity($event)">
                                                                <label class="f-light">Quantity</label>
                                                            </div>
                                                        </div>

                                                        <button type="button"
                                                            class="btn btn-02 f-large  addcart  new-btn cart-btn text-uppercase"
                                                            *ngIf="addOn.total_quantity > 0"
                                                            (click)="addToCart(addOn.id, $event)">
                                                            <span>ADD TO CART</span>
                                                        </button>


                                                    </div>
                                                    <div
                                                        class="d-flex align-items-center flex-column mb-2 out-stock-box">
                                                        <p class="mb-0 out-stk mb-1" *ngIf="addOn.total_quantity <= 0">
                                                            Out of stock
                                                        </p>
                                                        <button type="button"
                                                            class="btn btn-02 f-large  addcart new-btn notify-btn cart-btn"
                                                            *ngIf="addOn.total_quantity <= 0" (click)="notifyWhenAvailable(addOn.id)">
                                                            <span>Notify Me when Available</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row text-center" *ngIf="!isLoadingMore && hasNextPage && !isLoading && addOns.length">
                <div class="col-12">
                    <button type="button" class="btn btn-primary" (click)="loadMore()">Load More</button>
                </div>
            </div>
            <app-preloader *ngIf="isLoadingMore"></app-preloader>
        </div>
    </div>

</section>
<!--  -->

<div class="modal fade stock-modal" id="stockModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header border-0">
                <h5 class="modal-title" id="exampleModalLabel">Inventory</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body border-0">
                <div class="d-flex flex-row align-items-center justify-content-center inventory_loader">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span>&nbsp;&nbsp;Fetching Data ...</span>
                </div>
                <div class="table-responsive inventory_table">
                    <table class="table cart-table">
                        <thead>
                            <tr>
                                <th>Warehouse</th>
                                <th>Quantity</th>
                                <th>Ship From</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let inventory of inventoryData; let i = index">
                                <td>{{inventory.warehouse_name}}</td>
                                <td>
                                    <span *ngIf="inventory.quantity>0">{{ inventory.quantity }}</span>
                                    <span *ngIf="inventory.quantity<=0">{{ inventory.eta_qty }}pcs ETA {{
                                        inventory.eta}}</span>
                                </td>
                                <td>
                                    <input type="radio" name="stock" [checked]="i === 0"
                                        (change)="setWarehouse(clickedAccessoryID, inventory.id)" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>